export const CHANGE_CLIENT_VIEW = 'CHANGE_CLIENT_VIEW';
export const changeClientView = (isClientView) => ({
	type: CHANGE_CLIENT_VIEW,
	isClientView,
});

export const RESET_CLIENT_VIEW = 'RESET_CLIENT_VIEW';
export const resetClientView = () => ({
	type: RESET_CLIENT_VIEW,
});
